import styled from 'styled-components';
import { animations } from '@prisjakt/ui-base';

export const PriceHistorySummary = styled.div.attrs({
  'data-test': 'PriceHistorySummary',
})`
  min-height: 130px;
  background: ${props => props.theme.bg.secondary};
  border-radius: 8px;
`;

export const FadingBox = styled.div`
  background: ${props => props.theme.bg.primary};
  border-radius: 8px;
  animation: ${animations.fadeInKeyframes} 0.1s;
`;

export const PriceHistoryHeading = styled.span`
  color: ${props => props.theme.colors.base500};
  float: left;
`;

export const PriceHistoryWrapper = styled.div`
  position: relative;
`;

export const CurrentPrice = styled.div`
  text-align: right;
  color: ${props => props.theme.colors.base500};
  font-weight: 600;
`;
